const textFieldEquipStatusInput = {
  placeholder: 'Descreva o motivo...',
  helperText: '* campo obrigatório'
};

export default textFieldEquipStatusInput;
